import React, { useState } from 'react';
import { Calendar, Tag, Search } from 'lucide-react';
import { newsData } from '../mock/mockData';

const News = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tutte');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = [
    'Tutte',
    'Risultati Finanziari',
    'Progetti',
    'Governance',
    'Aggiornamenti Industriali'
  ];

  const allNews = [
    ...newsData,
    {
      id: 4,
      title: 'Rafforzamento attività O&M',
      category: 'Aggiornamenti Industriali',
      date: '2025-03-01',
      excerpt:
        'Consolidamento del portafoglio O&M con oltre 50 impianti in gestione per un totale superiore a 300 MWp.',
      image: '/photo5.jpeg'
    },
    {
      id: 5,
      title: 'Track record a 614 MWp',
      category: 'Progetti',
      date: '2025-02-15',
      excerpt:
        'TerniEnergia Progetti raggiunge 614 MWp di capacità installata tra Italia, Europa e Africa, confermando la leadership nel settore utility-scale.',
      image: '/photo4.jpeg'
    },
    {
      id: 6,
      title: 'Nuovi progetti utility-scale in Italia',
      category: 'Progetti',
      date: '2024-11-20',
      excerpt:
        'Completamento con successo di importanti commesse in Sicilia, Emilia-Romagna e Sardegna nel biennio 2024-2025.',
      image: '/photo6.jpeg'
    }
  ];

  const filteredNews = allNews.filter((news) => {
    const matchesCategory = selectedCategory === 'Tutte' || news.category === selectedCategory;
    const matchesSearch = news.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-[#081221] to-[#0d63ce]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="font-serif text-6xl md:text-7xl font-bold text-white mb-6">
            News & Press Releases
          </h1>
          <p className="text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            Aggiornamenti aziendali, comunicati stampa e notizie dal mondo TerniEnergia Progetti
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="py-12 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
            {/* Search */}
            <div className="relative w-full md:w-96">
              <Search
                className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
                size={20}
              />
              <input
                type="text"
                placeholder="Cerca nelle news..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0d63ce] focus:border-transparent"
              />
            </div>

            {/* Category Filters */}
            <div className="flex flex-wrap gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                    selectedCategory === category
                      ? 'bg-[#081221] text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-24 bg-[#f5f7fb]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews.map((news) => (
              <div
                key={news.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 overflow-hidden cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={news.image}
                    alt={news.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="flex items-center space-x-2 px-3 py-1 bg-[#0d63ce]/10 text-[#0d63ce] text-xs font-semibold rounded-full">
                      <Tag size={14} />
                      <span>{news.category}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-gray-500 text-sm">
                      <Calendar size={14} />
                      <span>{new Date(news.date).toLocaleDateString('it-IT')}</span>
                    </div>
                  </div>
                  <h3 className="font-serif text-2xl font-bold text-[#081221] mb-4 leading-tight">
                    {news.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{news.excerpt}</p>
                  <button className="text-[#0d63ce] font-semibold hover:text-[#081221] transition-colors flex items-center space-x-2">
                    <span>Leggi di più</span>
                    <span>→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredNews.length === 0 && (
            <div className="text-center py-16">
              <p className="text-2xl text-gray-500">Nessuna news trovata</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-serif text-5xl font-bold text-[#081221] mb-6">
            Resta Aggiornato
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            Iscriviti alla nostra newsletter per ricevere gli ultimi aggiornamenti aziendali e comunicati stampa.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              placeholder="Il tuo indirizzo email"
              className="flex-grow px-6 py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0d63ce] focus:border-transparent"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-[#081221] text-white rounded-lg font-semibold hover:bg-[#0d63ce] transition-colors whitespace-nowrap"
            >
              Iscriviti
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default News;
